<p>
  home-fitness-challenge-list works!
</p>
